import Vue from 'vue';
import VueSanitize from 'vue-sanitize';
import App from './App.vue';
import { i18n } from './locale';
import router from './router';
import store from './store';
import Bootstrap from './plugins/Bootstrap';
import AppGlobal from './utils/AppGlobal';

Vue.config.productionTip = false;
Vue.use(Bootstrap);
// Compared to legacy we need to skip below tags and Events for sure
/* "<script", "</script>",
"<javascript", "</javascript>",
"<iframe", "</iframe>",
"<vbscript", "</vbscript>",
"<object", "</object>",
"<img", "</img>",
"<marquee", "</marquee>",:::::::::::::::::(Handled in vue-sanitize)
"onerror", "onclick", "onload", "onmouseover", "onstart"
Refer https://www.raymondcamden.com/2019/11/26/sanitizing-html-in-vuejs
*/
// We need to include <img> with no other event due to Notice Editor
// and exclude any iframe tag in CP Portal
// Events are handled in EventSanitizer....

// eslint-disable-next-line prefer-const
let defaults = VueSanitize.defaults;
defaults.allowedTags = defaults.allowedTags.filter(t => t !== 'iframe');
defaults.allowedTags = defaults.allowedTags.concat(['img']);
defaults.allowedSchemes = defaults.allowedSchemes.concat(['data']);

Vue.use(VueSanitize, defaults);
Vue.mixin(AppGlobal);
new Vue({
  router,
  store,
  render: h => h(App),
  i18n,
}).$mount('#app');
